<template lang="pug">
div
    v-e24-nav-bar
    SectionTitle(isAccordions='true' :srcImage='imgHeader', :tall="tall", h1="Create New Project ")
    section.maincolumn
        .app-page.new-project
            .accordion-envelope
                .title-messages
                    //- h2 Create New Project

                    b-card(no-body='')
                        b-card-header.card-header(header-tag='header', role='tab', v-b-toggle.option1='' @click="hideLowMenu()")
                            input#btn1(type='radio', name="projectSelection", value="projectOption1", v-model="projectType" )
                            span.space-padding: | My project is a new detached residential (R3) habitable/heated building (up to 4 dwelling units)

                        b-collapse#option1(accordion='projectSelAccordion', v-on:shown="projectOprChange('projectOption1')" role='tabpanel')
                            b-card-body.inside
                                .content
                                    b-form-radio-group#newConstructRadios(v-model='newConstruct', name='newConstructRadios', @change="putFromRadio($event)")
                                        b-form-radio.label(value='1') New home, dwelling, or Accessory Dwelling Unit (ADU) Newly constructed addition
                                        br
                                        b-form-radio.label(value='2') Accessory structure (without kitchen / not a dwelling unit)
                                    b-form-group.spacing-ls
                                        b-form-checkbox.label(id="third-project", v-model='newConstructSubOption', :value='true', v-show="newConstruct==2") I can, or would like to, make improvements to the main house to help with compliance
                                projDetails(v-if="showCreateForm1", :project='project', :newConstruct='newConstruct', :addition='addition', :create='create', :cityChange='cityChange')

                    b-card(no-body='')
                        b-card-header.p-1(header-tag='header', role='tab', v-b-toggle.option2='' @click="hideLowMenu()")
                            input#btn2(type='radio', name="projectSelection", value="projectOption2", v-model="projectType")
                            span.space-padding: | My project is a Remodel and/or Addition to a dwelling, or Converted Space (up to 2 dwelling units) <help-button id=2509 />

                        b-collapse#option2(accordion='projectSelAccordion', v-on:shown="projectOprChange('projectOption2')", role='tabpanel')
                            b-card-body.inside
                                .content
                                    b-form-radio-group#addRadios(v-model='addition', name='addRadios', @change="additionOPtChange")
                                        b-form-radio.label(name="addition", value='1') Newly constructed addition
                                        br
                                        b-form-group.spacing-ls
                                            b-form-checkbox.label(id="fifth-project", v-model='aduNew', :disabled="addition!=1") This is an Additional Dwelling Unit (ADU) with legal kitchen
                                        b-form-radio.label(name="addition", value='2')
                                            | Existing space to be converted to living space
                                            help-button(id=2503)
                                        br
                                        b-form-group.spacing-ls
                                            b-form-checkbox.label(id="seventh-project", v-model='aduConv', :disabled="addition!=2") This is an Additional Dwelling Unit (ADU) with legal kitchen
                                        b-form-radio.label(name="addition", value='3') Remodel only. No addition nor conversion
                                projDetails(v-if="showCreateForm2", :btnText='createProjectText', :project='project', :newConstruct='newConstruct', :addition='addition', :create='create', :cityChange='cityChange')

                    b-card(no-body='')
                        b-card-header.p-1(header-tag='header', role='tab', v-b-toggle.option3='' @click="hideLowMenu()")
                            input#btn3(type='radio', name="projectSelection", value="projectOption3", v-model="projectType")
                            span.space-padding: | My project is Non-residential or Commercial
                        b-collapse#option3(accordion='projectSelAccordion', v-on:shown="projectOprChange('projectOption3')", role='tabpanel')
                            b-card-body.inside
                                p.label.center
                                    | Our Do-It-Yourself Title24 compliance tool does not support these project types. For these projects, we recommend using &nbsp;
                                    br
                                    app-link.link(:to="navLinks.fullService") Full Service Compliance

                    b-card(no-body='')
                        b-card-header.p-1(header-tag='header', role='tab', v-b-toggle.option4='' @click="hideLowMenu()")
                            input#btn4(type="radio", name="projectSelection", value="projectOption4", v-model="projectType")
                            span.space-padding: | My project involves more more than two (2) dwelling units (addition), or more than four (4) dwellings in a new building
                        b-collapse#option4(accordion='projectSelAccordion', v-on:shown="projectOprChange('projectOption4')", role='tabpanel')
                            b-card-body.inside
                                p.label.center
                                    | Our Do-It-Yourself Title24 compliance tool does not support these project types. For these projects, we recommend using &nbsp;
                                    br
                                    app-link.link(:to="navLinks.fullService")
                                        b Full Service Compliance

                    b-card(no-body='')
                        b-card-header.p-1(header-tag='header', role='tab', v-b-toggle.option5='' @click="hideLowMenu()")
                            input#btn5(type="radio", name="projectSelection", value="projectOption5", v-model="projectType")
                            span.space-padding: | My project involves <i>both</i> Converted Space <i>and</i> new Addition(s) <help-button id=2509 />
                        b-collapse#option5(accordion='projectSelAccordion', v-on:shown="projectOprChange('projectOption5')", role='tabpanel')
                            b-card-body.inside
                                p.label.center
                                    | Our Do-It-Yourself Title24 compliance tool does not support these project types. Converted Spaces are treated differently from Additions, and are more complex. For these projects, we recommend using &nbsp;
                                    br
                                    app-link.link(:to="navLinks.fullService") Full Service Compliance

        v-e24-footer(:build="build")

    md-snackbar(md-position='center', :md-duration='snackbar.duration', :md-active.sync='snackbar.show', md-persistent='')
        span {{ $t(snackbar.message) }}
        md-button.md-primary(@click='snackbar.show = false') {{ $t('label.ok') }}
</template>

<script>
import Vue from 'vue'
import _ from 'lodash'
import SectionTitle from '@/common/components/sectionTitle.vue'
import imageHeader from '@/common/img/create-project.jpg'
import easyBtn from 'Common/components/easy-btn.vue'
import projDetails from './proj-details.vue'
import readBuild from '../../util/readBuild'

export default {
	name: 'new-project',
	components: {
		SectionTitle,
		easyBtn,
		projDetails
	},
	data () {
		return {
			build: '',
			imgHeader: imageHeader,
			createProjectText: 'Create project',
			tall: 90,
			projectType: '',
			newConstruct: false,
			addition: false,
			newConstructSubOption: false,
			aduNew: false,
			aduConv: false,

			project: {
				name: '',
				zipCode: '',
				city: null,
				county: null
			},

			cityList: [],
			countyList: [],
			location: [],

			snackbar: {
				show: false,
				message: '',
				duration: 3000
			},
			navLinks: {},

			showCreateForm1: false,
			showCreateForm2: false
		}
	},
	beforeMount: function () {
		this.navLinks = this.$e24Common.storageService.findItem('navLinks', true)
	},
	beforeRouteEnter: (to, from, next) => {
		Vue.e24.geoService.loadLocation().then(location => {
			console.log('Location', location)
			next(vm => {
				vm.cityList = _.map(location, 'city')
				// vm.countyList = _.map(location, 'county')
				vm.location = location
				console.log('City list', vm.cityList)
				// console.log('County list', vm.countyList)
			})
		})
	},
	mixins: [readBuild],
	mounted () {
		this.build = this.getBuild()
	},
	methods: {
		newConstructOptionsChange (optSel) {
			console.log('newConstructOptionsChange', optSel)
		},
		putFromRadio (value) {
			this.showCreateForm1 = true
		},
		hideLowMenu () {
			this.showCreateForm1 = false
			this.showCreateForm2 = false
			this.newConstruct = false
			this.addition = false
			this.newConstructSubOption = false
			this.aduNew = false
			this.aduConv = false
		},
		projectOprChange (value) {
			this.hideLowMenu()
			this.projectType = value

			switch (value) {
			case 'projectOption1':
				this.newConstruct = ''
				this.addition = false // this option put off addition radio
				// this.showCreateForm = false // this option put on project details
				// console.debug(`this.newConstruct ${this.newConstruct}`)
				this.showCreateForm1 = false

				break
			case 'projectOption2':
				this.newConstruct = false // this option put off newCOnstructo radio
				this.addition = ''
				//  this.showCreateForm = false // this option put on project details
				// console.debug(`this.addition ${this.addition}`)
				this.showCreateForm1 = true
				break
			case 'projectOption3':
			case 'projectOption4':
			case 'projectOption5':
				this.hideLowMenu()
				break
			}
		},
		additionOPtChange (value) {
			this.showCreateForm2 = true
			this.aduNew = value === 2
			if (value === '1') {
				this.createProjectText = 'Create Addition'
			} else if (value === '2') {
				this.createProjectText = 'Create Conversion'
			} else if (value === '3') {
				this.createProjectText = 'Create Remodel'
			}
		},
		// Change city selection
		cityChange (selectedCity) {
			console.log('City change', selectedCity)
			const counties = _.chain(this.location)
				.filter({
					city: selectedCity
				})
				.map('county')
				.value()
			console.log('Counties', counties)
			this.countyList = counties
			this.project.county = counties[0]
		},
		// Attempt to create a new project
		create () {
			if (!this.project.name) {
				this.snackbar.message = 'Please enter a project name'
				this.snackbar.show = true
				return
			} else if (!this.project.zipCode) {
				this.snackbar.message = 'project zip code required'
				this.snackbar.show = true
				return
			} else if (this.project.zipCode.length < 5) {
				this.snackbar.message = 'Please enter a zip code valid'
				this.snackbar.show = true
				return
			}
			const project = {
				name: this.project.name,
				city: this.project.city,
				county: this.project.county,
				zipCode: this.project.zipCode,
				takeoff: 5,
				clmtZone: null,
				isActive: 1,
				isLocked: 0
			}

			switch (this.projectType) {
			case 'projectOption1': // New detached residential
				console.log('new construction', this.newConstruct)
				switch (this.newConstruct) {
				case '1':
					project.takeoff = 4 // New construction
					break
				case '2':
					if (this.newConstructSubOption) {
						project.takeoff = 5 // Existing plus addition
					} else {
						project.takeoff = 6 // Detached addition (new construction with detached addition extra fields)
					}
					break
				}
				break

			case 'projectOption2': // Remodel or addition to dwelling, or converted space
				console.log('Addtion', this.addition)
				switch (this.addition) {
				case '1':
					project.takeoff = 5 // Existing plus addition (Newly constructed addition)
					project.adu = this.aduNew
					break
				case '2':
					project.takeoff = 7 // Conversion (addition labeled as conversion)
					project.adu = this.aduConv
					break
				case '3':
					project.takeoff = 8 // Remodel only
					break
				}
				break
			}

			console.log('Takeoff', project.takeoff)

			if (!_.isNil(this.county) && !_.isNil(this.city)) {
				// Project climate zone
				const loc = _.find(this.location, {
					county: this.county,
					city: this.city
				})
				project.clmtZone = loc.clmtzone
				// console.log('Climate zone', project.clmtZone)
			}

			Vue.e24.projectService
				.insert(Vue.e24.security.currentUser.userId, project)
				.then(addedPrj => {
					// console.log('added project', addedPrj)
					const gotoProject = {
						name: 'project.takeoff',
						params: {
							id: addedPrj.projId
						}
					}
					// console.log('Goto project', gotoProject)
					this.$router.push(gotoProject)
				})
				.catch(error => {
					console.error('Error inserting project', error)
				})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/app/project/new-project.vue